import React from 'react';

type InterpolatedPhoneTextProps = {
  text?: string;
  phoneNumber?: string;
  linkClassName?: string;
};

export function InterpolatedPhoneText({
  text,
  phoneNumber,
  linkClassName,
}: InterpolatedPhoneTextProps): React.ReactNode {
  if (!text) {
    return null;
  }

  const [beforePhoneNumber, afterPhoneNumber] = text.split('{phoneNumber}');
  if (!phoneNumber || afterPhoneNumber === undefined) {
    return text;
  }

  return (
    <>
      {beforePhoneNumber}
      <a href={`tel:${phoneNumber.replace(/\s/g, '')}`} className={linkClassName}>
        {phoneNumber}
      </a>
      {afterPhoneNumber}
    </>
  );
}
